// extracted by mini-css-extract-plugin
module.exports = {"container":"TermsOfUse_container__25dJ0","wrapper":"TermsOfUse_wrapper__mGxT8","text":"TermsOfUse_text__2xKxk","logo":"TermsOfUse_logo__1NU5s"};